import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-masteragent',
  templateUrl: './masteragent.component.html',
  styleUrls: ['./masteragent.component.scss'],
})
export class MasteragentComponent {}
